export const TOKEN_UI_ENABLED = process.env.NEXT_PUBLIC_TOKEN_UI_ENABLED !== "false";
